export function RemoveLink (pEditor, pLink)
{
  var prevUnlinkValue;

  this.queryRemoveLinkEnabled = (pButton) =>
  {
    var checkParentTagA = /^a$/i;
    var currentRange;
    var startParentBlockElement, endParentBlockElement;
    var ret = false;

    if (BEditor.browser.isIE)
    {
      if (!(((pEditor.pToolbar && pEditor.pToolbar.isMouseDown) || pEditor.isDropdownOpen) && prevUnlinkValue != null))
      {
        prevUnlinkValue = pEditor.queryBasicCommandEnabled(pButton, 'unlink');
      }

      return prevUnlinkValue;
    }
    else
    {
      currentRange = pEditor.range.getCurrent();
      startParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.startContainer, pEditor.checkAllBlockTagsPlusA);
      endParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, pEditor.checkAllBlockTagsPlusA);

      if (startParentBlockElement == endParentBlockElement)
      {
        if (currentRange.endOffset - currentRange.startOffset < 2 && currentRange.startContainer.hasChildNodes() && currentRange.startContainer.childNodes[currentRange.startOffset])
        {
          if (currentRange.startContainer.childNodes[currentRange.startOffset].nodeName.toUpperCase() == 'A' ||
             (currentRange.startContainer.childNodes[currentRange.startOffset].nodeName.toUpperCase() == 'IMG' &&
              pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags)))
          {
            ret = true;
          }
        }
        else
        {
          if (pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags))
          {
            ret = true;
          }
        }
      }

      return ret;
    }
  };


  this.removeLink = (pButton) =>
  {
    var checkParentTagA = /^a$/i;
    var currentSelection, currentRange;
    var parentCurrentElement = null;
    var startParentBlockElement,
        endParentBlockElement,
        alt,
        title;

    if (!BEditor.browser.isIE)
    {
      if (pEditor.image.currentImage)
      {
        parentCurrentElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(pEditor.image.currentImage, checkParentTagA, pEditor.checkAllBlockTags);
      }
      else
      {
        currentRange = pEditor.range.getCurrent();
        startParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.startContainer, pEditor.checkAllBlockTagsPlusA);
        endParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, pEditor.checkAllBlockTagsPlusA);

        if (startParentBlockElement == endParentBlockElement)
        {
          if (currentRange.endOffset - currentRange.startOffset < 2 && currentRange.startContainer.hasChildNodes())
          {
            if (currentRange.startContainer.childNodes[currentRange.startOffset].nodeName.toUpperCase() == 'A')
            {
              parentCurrentElement = currentRange.startContainer.childNodes[currentRange.startOffset];
            }
            else if (currentRange.startContainer.childNodes[currentRange.startOffset].nodeName.toUpperCase() == 'IMG')
            {
              parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);
            }
          }
          else
          {
            parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);
          }
        }
      }

      if (!parentCurrentElement)
      {
        return false;
      }

      currentSelection = pEditor.range.selection.getCurrent();
      currentSelection.removeAllRanges();
      currentRange = pEditor.iFrameDoc.createRange();
      currentRange.selectNode(parentCurrentElement);
      currentSelection.addRange(currentRange);
    }

    if (pEditor.image.currentImage && pEditor.image.currentImage.parentNode.nodeName === 'A')
    {
      alt = pEditor.image.currentImage.getAttribute('alt');
      title = pEditor.image.currentImage.parentNode.getAttribute('title');
      pEditor.image.currentImage.setAttribute('title', ((title != null && title !== '') ? title : ((alt != null && alt !== '') ? alt : '')));
    }

    pEditor.execBasicCommand(pButton, 'unlink');

    if (!BEditor.browser.isIE && pEditor.image.currentImage)
    {
      pEditor.layer.objectFactory.selectNewElement(pEditor.image.currentImage);
    }
  };
}